import { useState } from 'react';
import { Banner as ForgeBanner, BannerItem as ForgeBannerItem } from '@athena/forge';
import athenaConfig from '../../config';
import { INFO_BANNER_MESSAGE_KEY_MAP_V2 } from '../../constants';
import { getLocalizedString } from '../../utils/i18n-utils';
import { isAthenaOneWebClient } from '../../utils/app-utils';
import { getAnetDb } from '../../utils/user-utils';

const BANNER_CONFIG = INFO_BANNER_MESSAGE_KEY_MAP_V2.ATHENISTASSSOWARNING;

const REDIRECT_PROXY_PATTERN = /^https:\/\/athenanet-redirect-proxy-(dev|preprod)\.platform\.athenahealth\.com/;

function isRedirectProxyUrl(redirectUri: string): boolean {
  return REDIRECT_PROXY_PATTERN.test(redirectUri);
}

function getTargetHostFromState(): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  const state = urlParams.get('state');
  if (!state) {
    return null;
  }
  try {
    const decodedState = JSON.parse(atob(state));
    return decodedState.TARGET_HOST || null;
  }
  catch {
    return null;
  }
}

export function getAthenistaSsoUrl(): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  const redirectUri = urlParams.get('redirect_uri');
  if (!redirectUri) {
    return null;
  }
  try {
    const anetHost = isRedirectProxyUrl(redirectUri) ? getTargetHostFromState() : redirectUri;
    if (!anetHost) {
      return null;
    }
    const url = new URL(anetHost);
    url.pathname = '/athenistasso';
    return url.href;
  }
  catch {
    return null;
  }
}

export function shouldShowAthenistasSsoWarningBanner(): boolean {
  const { env } = athenaConfig;
  const isNonProdEnv = env !== 'prod';
  const anetDb = getAnetDb();
  const hasAthenistaSsoUrl = !!getAthenistaSsoUrl();

  return isNonProdEnv && isAthenaOneWebClient() && !!anetDb && hasAthenistaSsoUrl;
}

export default function AthenistasSsoWarningBanner() {
  const [ isVisible, setIsVisible ] = useState(true);

  if (!isVisible || !shouldShowAthenistasSsoWarningBanner()) {
    return null;
  }

  const athenistaSsoUrl = getAthenistaSsoUrl();
  const headerText = getLocalizedString(BANNER_CONFIG.header);
  const descriptionPart1 = getLocalizedString(BANNER_CONFIG.descriptionPart1);
  const descriptionPart2 = getLocalizedString(BANNER_CONFIG.descriptionPart2);

  return (
    <div className="fe_u_margin--bottom-medium">
      <ForgeBanner alertType={BANNER_CONFIG.alertType} className="fe_u_padding--medium" onHide={() => setIsVisible(false) }>
        <ForgeBannerItem headerText={headerText}>
          {descriptionPart1}
          <a href={athenistaSsoUrl!} style={{ wordBreak: 'break-all' }}>
            {athenistaSsoUrl}
          </a>
          {descriptionPart2}
        </ForgeBannerItem>
      </ForgeBanner>
    </div>
  );
}

AthenistasSsoWarningBanner.displayName = 'AthenistasSsoWarningBanner';
